import React from 'react';
import { EpiBlock, EpiContent } from '@api/types';
import { BlockProperty, Image } from '@components';
import { Box, Container, styled } from '@mui/material';
import { breakpoints, palette } from '@themes/theme.helpers';

const ImageListBlockWrapper = styled('section')`
  background: ${palette.common('black')};
  color: ${palette.common('white')};
  .list {
    margin-block-start: 0;
    margin-block-end: 0;
    list-style: none;
    display: flex;
    justify-content: space-evenly;
    padding: 30px 10px;
    gap: 10px;
    ${breakpoints.up('md')} {
      padding: 60px;
    }
    // TODO [KF] - replace class
    .epi-image-wrapper {
      display: flex;
      justify-content: center;

      .epi-image {
        margin-bottom: 10px;
        height: 65px;
        width: 65px;
        ${breakpoints.up('sm')} {
          height: 75px;
          width: 75px;
        }
        ${breakpoints.up('md')} {
          height: 80px;
          width: 80px;
          margin-bottom: 28px;
        }
      }
    }

    .image-list-item-text {
      text-align: center;
      font-size: 14px;
      ${breakpoints.up('sm')} {
        font-size: 22px;
      }
      ${breakpoints.up('md')} {
        font-size: 24px;
      }
    }
  }
`;

export type ImageListBlockProps = {
  title: string;
  children?: React.ReactNode;
  content?: EpiContent;
};

export const ImageListBlock = ({ content = [] }: ImageListBlockProps) => {
  const shouldMapContent = Array.isArray(content);
  return (
    <ImageListBlockWrapper>
      <Container>
        <BlockProperty property='content'>
          <Box className='list' component='ul'>
            {shouldMapContent &&
              content.map((block, key) => <ImageListItem block={block} key={key} />)}
          </Box>
        </BlockProperty>
      </Container>
    </ImageListBlockWrapper>
  );
};

export type ImageListItemProps = {
  block?: EpiBlock;
};

export const ImageListItem = ({ block }: ImageListItemProps) => {
  return (
    <Box className='image-list-item' component='li'>
      <Image image={block?.contentLink?.expanded?.contentLink?.url} addWrapper />
      <Box className='image-list-item-text'>{block?.contentLink?.expanded?.title}</Box>
    </Box>
  );
};
